import React from 'react';
import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { formatDelta } from '../../utils/numberFormat';

/**
 * Una KPI: etichetta, numero grande, e sotto il confronto con il periodo precedente.
 * Il delta è null quando il periodo precedente è a zero: lì si scrive «n.d.», perché una variazione
 * rispetto a zero non esiste e inventarla produrrebbe una segnalazione.
 */
const UsageKpiCard = ({ label, value, delta, footer, loading, lead = false }) => {
  const deltaColor = delta > 0 ? 'success.main' : delta < 0 ? 'error.main' : 'text.secondary';

  return (
    <Card variant="outlined" sx={{ height: '100%', borderColor: lead ? 'primary.main' : undefined }}>
      <CardContent>
        <Typography variant="overline" color="text.secondary">
          {label}
        </Typography>

        {loading ? (
          <Skeleton variant="text" width="60%" height={56} />
        ) : (
          <Typography variant="h3" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
            {value}
          </Typography>
        )}

        <Box sx={{ mt: 1, display: 'flex', gap: 1, alignItems: 'baseline', flexWrap: 'wrap' }}>
          {delta !== undefined && (
            <Typography variant="body2" sx={{ color: deltaColor, fontWeight: 600 }}>
              {formatDelta(delta)}
            </Typography>
          )}
          {footer && (
            <Typography variant="body2" color="text.secondary">
              {footer}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default UsageKpiCard;
